import { useCallback } from 'react';
import { downloadFile, getCurrentDate, handleErrors } from '../common';

type ExportMutationTrigger = (body: any) => { unwrap: () => Promise<{ data: number[] }> };

/**
 * Encapsula el patrón de exportación a Excel server-side: el backend recibe los
 * filtros ya normalizados (sin paginado) y devuelve el archivo completo filtrado,
 * ignorando lo que esté paginado en la grilla. Reutilizable por cualquier módulo
 * que exponga una mutation de RTK Query que devuelva { data: number[] } (bytes del xlsx).
 */
const useServerExcelExport = (exportMutationTrigger: ExportMutationTrigger) => {
    const exportToExcel = useCallback(
        async (body: any, fileNamePrefix: string) => {
            try {
                const response = await exportMutationTrigger(body).unwrap();
                const bufferData = response?.data;
                if (!bufferData?.length) return;

                const blob = new Blob([new Uint8Array(bufferData)], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                downloadFile({ blob, name: `${fileNamePrefix}_${getCurrentDate()}.xlsx` });
            } catch (error) {
                handleErrors(error);
            }
        },
        [exportMutationTrigger]
    );

    return { exportToExcel };
};

export default useServerExcelExport;
